import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userInfo: {},
        routerList: {},

        // 详细信息
        // 类别列表
        categoryList: [],
        // 类型列表
        typeList: [],
        // 学科列表
        subjectList: []
    },
    mutations: {
        updateUserInfo(state, info) {
            state.userInfo = info;
        },
        updateRouterList(state, list) {
            state.routerList = list;
        },
        updateCategoryList(state, list) {
            state.categoryList = list;
        },
        updateTypeList(state, list) {
            state.typeList = list;
        },
        updateSubjectList(state, list) {
            state.subjectList = list;
        }
    },
    actions: {},
    modules: {}
});
